import React from 'react'
import { connect } from 'react-redux'
import TrendChart from '../TrendChart'
import TrendChartTFAArticle from '../TrendChartTFAArticle'

const SideCountryTrends = ({
  countries,
  indicators,
  selectedCountry,
  selectedCountryData,
  comparisonCountry,
  comparisonCountryData,
  indicatorsList = [],
  tfaArticlesList = [],
  tfaArticles,
  tfaArticlesDescriptions = {},
  tfaMeta,
}) => {
  return (
    <div className="w-100 mb5">
      {/* trends */}
      {selectedCountryData.data &&
        indicatorsList.map(indicator => {
          if (comparisonCountryData && comparisonCountryData.data) {
            return (
              <div key={indicator.globalId}>
                {indicator.shortTitle}
                <TrendChart
                  indicatorData={indicator}
                  countryCode={selectedCountry}
                  dataByCountry={selectedCountryData.data[indicator.globalId]}
                  comparisonCountryCode={comparisonCountry}
                  comparisonDataByCountry={
                    comparisonCountryData.data[indicator.globalId]
                  }
                />
              </div>
            )
          } else {
            return (
              <div key={indicator.globalId}>
                {indicator.shortTitle}
                <TrendChart
                  indicatorData={indicator}
                  countryCode={selectedCountry}
                  dataByCountry={selectedCountryData.data[indicator.globalId]}
                />
              </div>
            )
          }
        })}
      {true &&
        tfaArticlesList.map(indicator => {
          const { max } = tfaMeta[indicator]
          if (comparisonCountryData && comparisonCountryData.data) {
            return (
              <div key={indicator} className="border-bottom-blue">
                <div className="mb2 mt2">
                  TFA article {indicator}: {tfaArticlesDescriptions[indicator]}
                </div>
                <TrendChartTFAArticle
                  tfaArticle={indicator}
                  countryCode={selectedCountry}
                  dataByCountry={tfaArticles[indicator][selectedCountry]}
                  comparisonCountryCode={comparisonCountry}
                  valueMax={max}
                  comparisonDataByCountry={
                    tfaArticles[indicator][comparisonCountry]
                  }
                />
              </div>
            )
          } else {
            return (
              <div key={indicator} className="border-bottom-blue">
                <div className="mb2 mt2">
                  TFA article {indicator}: {tfaArticlesDescriptions[indicator]}
                </div>
                <TrendChartTFAArticle
                  tfaArticle={indicator}
                  indicatorData={indicator}
                  countryCode={selectedCountry}
                  valueMax={max}
                  dataByCountry={tfaArticles[indicator][selectedCountry]}
                />
              </div>
            )
          }
        })}
    </div>
  )
}

const mapStateToProps = state => ({
  countries: state.countries,
  indicators: state.indicators,
  selectedCountry: state.selectedCountry,
  selectedCountryData: state.selectedCountryData,
  comparisonCountry: state.comparisonCountry,
  comparisonCountryData: state.comparisonCountryData,
})

export default connect(mapStateToProps)(SideCountryTrends)



// WEBPACK FOOTER //
// ./src/components/SideCountryTrends/index.js